export default "__VITE_ASSET__HkZiC_xP__"